import React from "react";

const SvgOdometer = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Odometer_svg__b"
        d="M702.338 706.83c-1.341 3.25-3.482 8.305-3.972 9.001-.386.516-.98.825-1.573.825-.387 0-.748-.103-1.11-.36-.85-.62-1.082-1.806-.463-2.683.49-.696 4.539-4.436 7.118-6.783"
      />
      <path id="Odometer_svg__a" d="M687 705h20.023v20H687z" />
      <path
        id="Odometer_svg__d"
        d="M699.064 705.508c-1.15.008-2.248.204-3.26.526-1.009.333-1.942.783-2.742 1.39-1.61 1.187-2.745 2.822-3.276 4.565a8.38 8.38 0 0 0 .144 5.228c.299.81.73 1.566 1.277 2.225a7.611 7.611 0 0 0 1.899 1.699 7.173 7.173 0 0 0 2.336 1.002c.828.208 1.701.256 2.566.196 1.732-.117 3.423-.875 4.787-2.093.169-.154.344-.306.493-.48.151-.173.33-.33.46-.522l.212-.279c.072-.093.149-.183.204-.286.119-.201.259-.395.38-.6l.327-.638c.094-.22.173-.447.272-.672.052-.111.083-.229.117-.346l.105-.354c.085-.235.112-.48.166-.725.123-.492.158-1 .181-1.514a10.62 10.62 0 0 0-.072-1.566 9.289 9.289 0 0 0-.338-1.584 11.15 11.15 0 0 0-.588-1.582l-.012-.03a.136.136 0 0 1 .23-.137c1.418 1.82 2.196 4.156 2.08 6.479a9.839 9.839 0 0 1-.733 3.391 10.152 10.152 0 0 1-1.868 2.928c-1.565 1.718-3.743 2.9-6.067 3.184a10.43 10.43 0 0 1-3.482-.133 9.737 9.737 0 0 1-3.228-1.325c-1.97-1.262-3.484-3.218-4.183-5.45a10.27 10.27 0 0 1-.442-3.453c.05-1.162.284-2.325.742-3.398a10.151 10.151 0 0 1 4.616-5.046 9.638 9.638 0 0 1 3.308-1.02c.144-.017.286-.05.431-.052l.434-.018c.289-.013.578-.028.866-.009a9.981 9.981 0 0 1 1.716.23.136.136 0 0 1-.029.269z"
      />
      <clipPath id="Odometer_svg__c">
        <use xlinkHref="#Odometer_svg__a" />
      </clipPath>
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#Odometer_svg__b"
      transform="translate(-687 -705)"
    />
    <g clipPath="url(#Odometer_svg__c)" transform="translate(-687 -705)">
      <use fill="currentColor" xlinkHref="#Odometer_svg__d" />
    </g>
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgOdometer svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Odometer.js